import { useState } from "react";
import { Star, ExternalLink, MessageSquareHeart } from "lucide-react";

export const ReviewsDemo = () => {
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);

  return (
    <div data-testid="reviews-demo">
      <div className="text-center">
        <div className="text-sm text-[#a9a398]">Xidmətdən sonra müştəriyə gələn mesaj</div>
        <div className="font-display text-lg font-semibold mt-1">Xidmətimizi necə qiymətləndirirsiniz?</div>
        <div className="flex justify-center gap-2 mt-4" onMouseLeave={() => setHover(0)}>
          {[1, 2, 3, 4, 5].map((n) => (
            <button key={n} onMouseEnter={() => setHover(n)} onClick={() => setRating(n)} data-testid={`review-star-${n}`} className="p-1 transition-transform hover:scale-110">
              <Star className={`h-9 w-9 ${(hover || rating) >= n ? "fill-amber-400 text-amber-400" : "text-[#5c5850]"}`} />
            </button>
          ))}
        </div>
      </div>
      {rating >= 4 && (
        <div className="mt-5 rounded-xl bg-white text-[#1a1917] p-4" data-testid="review-google-redirect">
          <div className="flex items-center gap-2 text-sm font-semibold">
            <span className="font-bold"><span className="text-blue-600">G</span><span className="text-red-500">o</span><span className="text-amber-500">o</span><span className="text-blue-600">g</span><span className="text-green-600">l</span><span className="text-red-500">e</span></span>
            Rəy yazın
          </div>
          <div className="flex gap-0.5 mt-2">{Array.from({ length: rating }).map((_, i) => <Star key={i} className="h-4 w-4 fill-amber-400 text-amber-400" />)}</div>
          <p className="text-xs text-[#8b867c] mt-2">Müştəri avtomatik olaraq Google səhifənizə yönləndirilir.</p>
          <div className="mt-3 inline-flex items-center gap-1 text-xs text-blue-600 font-semibold">Google-da paylaş <ExternalLink className="h-3 w-3" /></div>
        </div>
      )}
      {rating > 0 && rating <= 3 && (
        <div className="mt-5 rounded-xl bg-white/5 border border-white/10 p-4" data-testid="review-private-feedback">
          <div className="flex items-center gap-2 text-sm font-semibold text-amber-200"><MessageSquareHeart className="h-4 w-4" /> Rəyiniz birbaşa rəhbərliyə çatdı</div>
          <p className="text-xs text-[#a9a398] mt-2">Narazı müştərinin fikri əvvəlcə sizə gəlir — problemi həll etməyə vaxtınız olur.</p>
        </div>
      )}
    </div>
  );
};
